<div class="product-purchase-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="productPurchaseForm">
  <div class="buttons" fxLayout="row" fxLayoutGap="15px">
    <button tabindex="-1" (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!productPurchaseForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon> <span> Zapisz</span>
    </button>
    <button tabindex="-1" (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon> <span> Anuluj</span>
    </button>
  </div>

  <div fxFlex="100" fxLayout="row" fxLayoutGap="10px">
    <mat-card fxFlex="100">
      <div fxLayout="column" fxLayoutGap="10px">
        <h3>Dodatkowa dostawa</h3>

        <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
          <div fxLayout="row" fxFlex="50">
            <app-datepicker
              fxFlex="100"
              label="Data zakupu"
              placeholder="2000-01-01 00:00"
              [required]="true"
              [control]="purchaseDateControl"
            ></app-datepicker>
          </div>

          <app-dict fxFlex="50" dictType="marketing_companies" label="Firma"
                    [control]="companyControl"
                    [required]="true"></app-dict>
        </div>

        <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
          <div fxLayout="row" fxFlex="50">
            <app-datepicker
              fxFlex="100"
              label="Data ważności"
              placeholder="2000-01-01 00:00"
              [required]="false"
              [control]="expirationDateControl"
            ></app-datepicker>
          </div>

          <mat-form-field fxFlex="50">
            <mat-label>Ilość</mat-label>
            <input matInput placeholder="Ilość"
                   type="number"
                   min="0"
                   formControlName="amount"
                   [required]="true">
          </mat-form-field>
        </div>
      </div>
    </mat-card>
  </div>

  <div class="buttons" fxLayout="row" fxLayoutGap="15px">
    <button tabindex="-1" (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!productPurchaseForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon> <span> Zapisz</span>
    </button>
    <button tabindex="-1" (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon> <span> Anuluj</span>
    </button>
  </div>
</div>
